module.exports = __webpack_public_path__ + "img/ampel_pin_grün.abdcf3f6.svg";